<section class="section skills">
  <div class="container" style="max-width: 85%;">
    <div class="content">
      <div class="columns is-centered">
        <div class="column is-one-fifth">
          <h6 class="is-center is primary">Is this a new item?</h6>
          <div>
            <label class="radio">
              <input (click)="radioBtnClick('new')" [(ngModel)]="isNew" type="radio" [value]="true" name="isNew">
              Yes
            </label>
            <label class="radio">
              <input [(ngModel)]="notNew" (click)="radioBtnClick('no')" [value]="true" type="radio" name="notNew">
              No
            </label>
          </div>
          <br />
          <div *ngIf="notNew" class="control">
            <label class="label">Select Question</label>
            <input type="text" name="filter" placeholder="Filter questions" style="padding: 5px;"
              [value]="questionFilterText" (change)="questionFilter($event.target.value)" />
            <br />
            <busy-indicator [show]="loading_question" [margins]="false">
              <div class="select" style="max-width: 300px;">
                <select (change)="getQuestionDataById($event.target.value)">  
                  <option *ngFor="let item of filteredQuestions" [value]="item.id">
                    {{item.question_text}}
                  </option>
                </select>
              </div>
            </busy-indicator>
            <br />
            <br />
            <div class="control" *ngIf="questionSelected && question">
              <br />
              <label class="label">Select Question Version:</label>
              <busy-indicator [show]="loading_question" [margins]="true">
                <div class="select" style="max-width: 190px;">
                  <select id="question-select" [(ngModel)]="selectedVersion"
                    (change)="getQuestionVersionData($event.target.value)">
                    <option *ngFor="let item of question.questionVersions" [value]="item.value">{{item.value}}</option>
                  </select>
                </div>
                <br />
                <br />
                <label class="label">Archive Question</label>
                <input type="checkbox" [(ngModel)]="question.question_archived" />
              </busy-indicator>
            </div>
          </div>
          <div>
            <div class="control">
              <button (click)="saveQuestionInfo()" class="button is-primary">Save Question Info</button>
            </div>
          </div>
        </div>
        <div class="column is-four-fifths" *ngIf="newRubricPrompt && question">
          <div class="tabs">
            <ul>
              <li id="process" (click)="setTab('process')" class="is-active"><a>Question Text and Rubric Description</a>
              </li>
              <li *ngIf="showCategory" id="category" (click)="setTab('category')"><a>Category Setup</a></li>
            </ul>
          </div>
          <div *ngIf="isProcess">
            <busy-indicator [show]="loading_question || loadingRevision">
              <div class="field has-text-left">
                <label class="label">Name of Question</label>
                <div class="control">
                  <input [readOnly]="existingQuestion" [(ngModel)]="question.question_name" class="input"
                    style="max-width: 550px;" type="text">
                  <div class="error" *ngIf="hasError('QuestionNameRequired')">
                    ** Required - must have a value **
                  </div>
                </div>
                <label class="label">Input Question Text</label>
                <div class="control">
                  <input [readOnly]="existingQuestion" class="input" [(ngModel)]="question.question_text"
                    style="max-width: 550px;" type="text">
                  <div class="error" *ngIf="hasError('QuestionTextRequired')">
                    ** Required - must have a value **
                  </div>
                </div>
                <label class="label">Brief description of Prompt and Rubric</label>
                <div class="control">
                  <input class="input" [(ngModel)]="question.brief_rubric_description" style="max-width: 550px;"
                    type="text">
                </div>
              </div>
              <h6 class="is-center is primary">Rubric Type</h6>
              <div *ngIf="question.revision_date == '' || question.rubricLevels.length == 0">
                <label class="radio">
                  <input [(ngModel)]="modelSettings.Analytic" [value]="true" type="radio"
                    (click)="handleType('analytic')" name="analytic">
                  Analytic
                </label>
                <label class="radio">
                  <input type="radio" [(ngModel)]="modelSettings.Holistic" [value]="true"
                    (click)="handleType('holistic')" name="holistic">
                  Holistic
                </label>
              </div>
              <div *ngIf="question.revision_date != '' && question.rubricLevels.length > 0">
                <span *ngIf="modelSettings.Analytic">Analytic</span>
                <span *ngIf="modelSettings.Holistic">Holistic</span>
              </div>
              <br />
              <br />

              <table class="table is is-bordered" style="max-width: 750px;">
                <thead>
                  <tr>
                    <th *ngIf="modelSettings.Holistic" style="width: 100px;">
                      <div class="relative"><span class="colHeader">Code</span></div>
                    </th>
                    <th style="width: 150px;">
                      <div class="relative"><span class="colHeader">Rubric Title</span></div>
                    </th>
                    <th style="width: 300px;">
                      <div class="relative"><span class="colHeader">Description</span></div>
                    </th>
                    <th style="width: 100px" *ngIf="modelSettings.Analytic && question.rubricLevels.length > 0">
                      <span class="colHeader">Category Code</span>
                    </th>
                    <th *ngIf="question.rubricLevels.length > 0" style="width: 50px"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of question.rubricLevels; index as i">
                    <td *ngIf="modelSettings.Holistic">
                      <input class="input" type="text" [(ngModel)]="item.rubric_code">
                    </td>
                    <td>
                      <input class="input" type="text" [(ngModel)]="item.rubric_level">
                    </td>
                    <td>
                      <input class="input" type="text" [(ngModel)]="item.description">
                    </td>
                    <td *ngIf="showCategory">
                      {{item.short_code}}
                    </td>
                    <td>
                      <span *ngIf="item.id == null || item.id == 0">New</span>&nbsp;&nbsp;
                      <button *ngIf="item.id == null || item.id == 0" class="cancel"
                        (click)="cancelBin(i)">Cancel</button>
                      <button *ngIf="item.id > 0" class="delete" title="Remove Bin"
                        (click)="deleteBin(item.id)">Delete</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button *ngIf="question" class="button is-info" (click)="addRubric()">
                {{addRubricButtonText()}}</button>
              <br />
              <br />
              <br />
              <p *ngIf="question">Version: {{question.question_version}} {{question.revision_date}}</p>
            </busy-indicator>
          </div>
          <div class="column" *ngIf="isCategory">
            <div class="field has-text-left">
              <div>
                <label class="label"> Category Name </label>
                <input class="input" [(ngModel)]="questionCat.name" style="max-width: 650px;" type="text" value="">
              </div>
              <div>
                <label class="label"> Category Description </label>
                <input class="input" style="max-width: 650px;" [(ngModel)]="questionCat.description" type="text"
                  value="">
              </div>
              <div>
                <div style="display: inline;">
                  <label class="label" style="display: inline;">
                    Relation
                  </label>
                  <a href="#" (click)="showRelationHelp('relation_help')">[help]</a>
                  <input class="input" style="max-width: 650px;" placeholder="e.g. BIN1 > 1" type="text"
                    [(ngModel)]="questionCat.relation" value="">
                  <div *ngIf="relation_help">
                    <em>Codes <span class="small">(hover to see help text)</span></em>
                    <div *ngIf="question.rubricLevels.length == 0">
                      &nbsp;&nbsp;It appears that a rubric has not be setup
                    </div>
                    <ul class="inline-list" *ngIf="question.rubricLevels">
                      <li *ngFor="let item of question.rubricLevels" class="tag is-warning"
                        title="Use the code {{item.short_code}} to reference this title in a term">{{item.rubric_level}}
                        =&nbsp;<strong>{{item.short_code}}</strong></li>
                    </ul>
                    <br />

                    <em>Operations <span class="small">(hover to see help text)</span></em>
                    <ul class="inline-list">
                      <li class="tag is-dark" title="Equal">=</li>
                      <li class="tag is-dark" title="Not Equal">&lt;&gt;</li>
                      <li class="tag is-dark" title="Greater Than Equal">&gt;=</li>
                      <li class="tag is-dark" title="Less Than Equal">&lt;=</li>
                      <li class="tag is-dark" title="Greater Than">&gt;</li>
                      <li class="tag is-dark" title="Less Than">&lt;</li>
                    </ul>
                    <br />

                    <em>Grouping</em><br />
                    &nbsp;&nbsp;AND(<em>term1</em>, <em>term2</em>, ...), OR(<em>term1</em>, <em>term2</em>, ...)
                    <br /><br />
                    <em>Examples</em>
                    <ul>
                      <li>BIN1 > 0 <em>notes:</em> You can define a single term</li>
                      <li>OR(BIN1 > 0, BIN2 = 1) <em>notes:</em> You can define a single group</li>
                      <li>AND(BIN2 = 1, OR(BIN2 = 0, BIN1 <> 0)) <em>notes:</em> You can nest group functions of terms
                      </li>
                    </ul>
                  </div>
                  <br />
                  <br />
                </div>
              </div>
              <br />
              <button *ngIf="question" class="button is-info" (click)="addQuestionCat()">Add Category</button>
            </div>
            <table class="table is is-bordered" style="max-width: 750px;">
              <colgroup>
                <col style="width: 50px;">
                <col style="width: 150px;">
                <col style="width: 180px;">
              </colgroup>
              <thead>
                <tr>
                  <th class="">
                    <div class="relative"><span class="colHeader">Name</span></div>
                  </th>
                  <th class="">
                    <div class="relative"><span class="colHeader">Description</span></div>
                  </th>
                  <th class="">
                    <div class="relative"><span class="colHeader">Relation</span></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of questionCats">
                  <td>
                    {{item.name}}
                  </td>
                  <td>
                    {{item.description}}
                  </td>
                  <td>
                    {{item.relation}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

